import { useEffect, useRef } from 'react';

export const usePageRefresh = (onRefresh?: () => void) => {
  const isRefreshing = useRef(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      isRefreshing.current = true;
      if (onRefresh) {
        onRefresh();
      }
    };

    const handleLoad = () => {
      if (isRefreshing.current) {
        // Sayfa refresh edildi
        isRefreshing.current = false;
        if (onRefresh) {
          onRefresh();
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, [onRefresh]);

  return isRefreshing.current;
};















